import { probalityOccurenceInfoMapper } from 'pages/NotifyEvent/constant_text'
import { IoCloseSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { VariableReducer } from 'types/variable'

interface IProbabilityOccurenceModal {
  close: () => void
  chooseProbabilityOccurence: (id: string) => void
  chosenElementId: string
  isReadOnly: boolean
}
export default function ProbabilityOccurenceModal({ close, chooseProbabilityOccurence, chosenElementId, isReadOnly }: IProbabilityOccurenceModal) {
  //redux state
  const variableSelector: VariableReducer = useSelector(
    (state: RootReducerState) => state.variableReducers
  )
  const dmgLevelList = variableSelector.variablesListDamageLevel
    ?.slice(1)
  
    const infoGetRoundedStyle = (idx: number, length: number) => {
      if (idx === 0) return 'rounded-t-lg'
      if (idx === length - 1) return 'rounded-b-lg'
      return ''
  }

  return (
    <div data-testid="test-dmg-lvl-modal" className="md:p-8 text-left  md:max-w-[1022px] ">
      <div className='flex'>
        <p className="text-xl font-semibold text-yellow">Probabilidade</p>
        <div
          className='ml-auto cursor-pointer'
          data-testid="test-close-dmg-lvl-modal"
          onClick={close}
        >
          <IoCloseSharp
            className="text-blueTheme h-8 w-8 p-1 cursor-pointer "
          />
        </div>
      </div>
      <p className="text-darkGray text-xs">
        
      </p>
      <div className='mt-4'>
        {probalityOccurenceInfoMapper.map((probabilityOccurItem, idx) => {
          const roundedStyle = infoGetRoundedStyle(idx, probalityOccurenceInfoMapper.length)
          const isSelected = false // id === chosenElementId
          return (
            <div
              key={idx} 
              onClick={() => {
                if (!isReadOnly) {
                  chooseProbabilityOccurence(`${probabilityOccurItem.probality}`)
                }
              }}
              className={`${!isReadOnly ? 'hover:border-[#F0B323] cursor-pointer' : 'cursor-default'} border ${isSelected ? "bg-[#FFFCF3] border-[#F0B323]" : "border-[#EBEFF5]"} ${roundedStyle} flex md:flex-row flex-col justify-start px-2 md:px-6 py-2 md:items-center`}>
              <div className=' md:w-[15%] mr-10'>
                <p className="text-blueTheme font-semibold text-sm md:text-base">
                  {probabilityOccurItem.label}
                </p>
              </div>
              <p className="text-darkGray md:text-sm w-[100%] text-[10px]">{probabilityOccurItem.info}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
